<template>
    <div>
        <div class="setLeft">
            <div class="top" @click="linkKefu">
                <i class="iconfont icon-Customerservice"></i>
                <p>电话客服</p>
            </div>
            <a :href="onlineUrl" v-if="onlineUrl" target="_blank">
                <div class="middle" id="zaixiankefu">
                    <i class="iconfont" :class="onlineIcon"></i>
                    <p>在线客服</p>
                </div>
            </a>
            <div class="middle" id="zaixiankefu" @click="zaixiankefu" v-else>
                <i class="iconfont" :class="onlineIcon"></i>
                <p>在线客服</p>
            </div>
            <BackTop :height="20" :right="0" :bottom="32">
                <div class="con">
                    <div class="back-top">
                        <!-- <Icon class="top" type="chevron-up"></Icon> -->
                        <i class="iconfont icon-arrowupper"></i>
                        <p>返回顶部</p>
                    </div>
                </div>
            </BackTop>
            <contact-box ref="box"></contact-box>
        </div>
        <div class="couponButton" v-if="isZhulogic && couponList.length > 0 && couponBouton.status === 1"  @click="showCouponDialog">
            <i class="iconfont icon-xinrenli-"></i>
            <p>新人礼</p>
        </div>

        <div  v-if="isZhulogic && couponAlert && couponAlert.length>0 && clickIsCoupon && firstClick > 0 && couponList.length > 0 "
              v-for="(item,index) in couponAlert"
              :key="index">
            <coupon-dialog :value="item" :index="index" @closeDialogHandle="closeDialogHandle"></coupon-dialog>
        </div>
    </div>

</template>
<style rel="stylesheet/scss" lang="scss" type="text/scss">
    .setLeft {
        background: #FFFFFF;
        border-radius: 3px;
        width: 72px;
        height: 162px;
        position: fixed;
        right: 0px;
        bottom: 124px;
        z-index: 5000;
        padding: 12px 4px;
        > .top,
        .middle {
            display: inline-block;
            height: 70px;
            width: 100%;
            text-align: center;
            line-height:1.5;
            border-bottom: 1px solid #DCE0E0;
            cursor: pointer;
            > i {
                color: #353838;
                display: inline-block;
                font-size: 33px;
            }
            p {
                font-size: 12px;
                color: #555555;
                margin-top: -5px;
            }
            &:hover > i {
                color: #f5a623;
            }
            &:hover p {
                color: #f5a623;
            }
        }
        .middle {
            height: 80px;
            border-bottom: none;
            i {
                display: inline-block;
                margin-top: 5px;
                color: #353838;
            }
        }
        .con {
            width: 72px;
            text-align: center;
            height: 94px;
            background: #fff;
            padding: 0 4px;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
            .back-top {
                height: 100%;
                width: 100%;
                border-top: 1px solid #DCE0E0;
                line-height: 1.5;
                p {
                    text-align: center;
                    font-size: 12px;
                    color: #555555;
                }
                .top {
                    font-size: 20px;
                    color: #555;
                    padding: 0px;
                    margin-top: 25px;
                }
                &:hover p {
                    color: #f5a623;
                }
                &:hover .top {
                    color: #f5a623;
                }
                &:hover .icon-arrowupper  {
                    color: #f5a623;
                }
                .icon-arrowupper {
                    color:#353838;
                    margin-top: 5px;
                    display: inline-block;
                }
            }
        }

    }
    .couponButton{
        width: 72px;
        position: fixed;
        right: 0px;
        bottom: 280px;
        z-index: 5000;
        cursor: pointer;
        text-align: center;
        height: 85px;
        background: -webkit-linear-gradient(#F5A623, #EF790F); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(#F5A623, #EF790F); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#F5A623, #EF790F); /* Firefox 3.6 - 15 */
        background: linear-gradient(#F5A623, #EF790F); /* 标准的语法 */
        >i{
            font-size: 33px;
            margin-top: 10px;
            display: inline-block;
            color:#fff;
        }
        >p{
            color:#fff
        }

        >img{
            width: 100%;
        }
    }

</style>
<script>
    import contactBox from './contactBox.vue'
    import api from '../../api'
    import couponDialog from './couponDialog.vue'
    import config from '../../config/config'

    export default {
        data(){
            return {
                couponAlert:[],
                couponBouton:'',
                couponShowIndex:0,
                firstClick:0,
                isZhulogic: config.isZhulogic
            }
        },
        props: {
            onlineIcon: {
                type: String,
                default: 'icon-service'
            },
            onlineUrl: {
                type: String
            }
        },
        computed: {
            clickIsCoupon(){
                return this.$store.state.app.clickIsCoupon;
            },
            couponList(){
                return this.$store.state.app.couponList;
            }
        },
        components: {
            contactBox,couponDialog
        },
        methods: {
            closeDialogHandle(index) {
//                this.couponShowIndex = index + 1;
                this.$store.dispatch('get_coupon_click', false)
            },
            get_coupon_list(){
                if(this.couponList.length > 0){
                    this.couponAlert = this.couponList.filter(item => item.type === 3);
                }
            },
            zaixiankefu(){
                api.notices.online_message_delete()
                    .then(res => {

                    })
            },
            linkKefu() {
                this.$refs.box.open();
            },
            showCouponDialog() {
                this.firstClick = this.firstClick + 1;
                if(!this.clickIsCoupon){
                    this.$store.dispatch('get_coupon_click',true);
                    this.get_coupon_list();
                }
            }
        },
        watch:{
            'couponList':function () {
                this.couponBouton = this.couponList.length > 0 && this.couponList.filter(item => item.type === 2)[0];
                this.get_coupon_list();
            }
        },
        created() {
            this.couponBouton = this.couponList.length > 0 && this.couponList.filter(item => item.type === 2)[0];
            this.get_coupon_list();
        }
    }
</script>